import { lazy } from 'react';
import { Boxes, CheckCheck, Settings, Users } from 'lucide-react';
import type { ModuleDefinition } from '../types';

const ChecksPage = lazy(() => import('./pages/checks'));
const ClientsPage = lazy(() => import('./pages/clients'));
const SettingsPage = lazy(() => import('./pages/settings'));
const UsersPage = lazy(() => import('./pages/users'));

/**
 * The Configure section: what runs, who it runs for, and where the results are sent.
 *
 * @since 1.0.0
 */
export const configureModule: ModuleDefinition = {
    id: 'configure',
    navSection: { label: 'Configure', order: 2 },
    items: [
        {
            id: 'checks',
            label: 'QC checks',
            icon: CheckCheck,
            path: '/checks',
            title: 'QC checks',
            badge: 'live-checks',
            actions: [{ id: 'new-check', label: 'New check', variant: 'dark' }],
        },
        {
            id: 'clients',
            label: 'Clients',
            icon: Boxes,
            path: '/clients',
            title: 'Clients',
            badge: 'client-count',
        },
        {
            id: 'settings',
            label: 'Settings',
            icon: Settings,
            path: '/settings',
            title: 'Settings',
        },
        {
            id: 'users',
            label: 'Users',
            icon: Users,
            path: '/users',
            title: 'Users',
            minRole: 'admin',
            actions: [{ id: 'add-user', label: 'Add user', variant: 'dark' }],
        },
    ],
    routes: [
        { path: '/checks', Component: ChecksPage },
        { path: '/clients', Component: ClientsPage },
        { path: '/settings', Component: SettingsPage },
        { path: '/users', Component: UsersPage },
    ],
};
